<template>
    <div v-show="showEvaluation">
        <p class="body-1 grey--text text--darken-1 mt-4">{{ $t('label.demandEvaluation')}}</p>
        <v-card>
            <v-card-text>
                    <v-layout row class="alignClass">
                        <star-rating 
                            :item-size="25" 
                            inactive-color="#eee" 
                            active-color="#fb8c00"
                            :show-rating="false"
                            v-model="evaluationForm.score"
                            @rating-selected="scoreValue"
                            spacing=0
                        ></star-rating>

                        <v-btn
                            icon
                            class="pa-2 dotsClass"
                            @click="toggleEvaluationComment">
                            <v-icon class="threedots">more_horiz</v-icon>
                        </v-btn>
                    </v-layout>
                    <v-layout row v-show="displayEvaluationComment">
                        <v-flex>
                            <v-text-field  multi-line v-model="evaluationForm.comment" auto-grow :counter="constants.LENGTH_DESCRIPTION" :maxlength="constants.LENGTH_DESCRIPTION"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-btn @click="saveEvaluation" color="primary">Enviar</v-btn>
                    <v-btn v-if="this.$store.getters.evaluation.id !== 0" @click="removeEvaluation" color="error">Excluir</v-btn>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import constants from "@/helpers/constants";
import utilities from "@/helpers/utilities";
import validation from "@/helpers/validation";

import Evaluation from "@/helpers/entities/Evaluation";

import {StarRating} from 'vue-rate-it';

export default {
    data() {
        return {
            constants,
            validation,
            utilities,
            evaluationForm: Evaluation.build(),
            oldScoreValue: 0,
            displayEvaluationComment: true
        };
    },

    computed: {
        showEvaluation() {
            if (this.$store.getters.demand.owner.id === this.$store.getters.profile.person.id &&
                this.$store.getters.demand.status.id === 6 &&
                this.$store.getters.demand.office.controlEvaluation === true &&
                this.$store.getters.demand.allowedEvaluationSupplier === true
            ) {
                this.loadEvaluation();
                return true;
            }
            return false;
        }
    },
    components: {
        StarRating
    },
    methods: {
        async saveEvaluation() {
            const model = Evaluation.build();
            model.demand.id = this.$store.getters.demand.id;
            model.person.id = this.$store.getters.profile.person.id;
            model.score = this.evaluationForm.score;
            model.isActive = true;
            model.comment = this.evaluationForm.comment;
            model.id = this.evaluationForm.id;
            console.log(model, "model");
            await this.$store.dispatch("saveOrUpdateEvaluation", Evaluation.toPayload(model));
            await this.loadEvaluation();
        },

        async removeEvaluation() {
            await this.$store.dispatch("removeEvaluation", Evaluation.toPayload(this.evaluationForm));
            await this.loadEvaluation();
        },
        async loadEvaluation() {
            const data = {
                demandId: this.$store.getters.demand.id,
                personId: this.$store.getters.profile.person.id
            };

            await this.$store.dispatch("getEvaluation", data);
            this.evaluationForm = this.$store.getters.evaluation;
        },
        async scoreValue() {
            if (this.oldScoreValue === this.evaluationForm.score) {
                this.evaluationForm.score = 0;
            }
            this.oldScoreValue = this.evaluationForm.score;
        },

        toggleEvaluationComment() {
            if (this.displayEvaluationComment === false) {
                this.displayEvaluationComment = true;
            } else {
                this.displayEvaluationComment = false;
            }
        },
    }
};
</script>

<style>
    .alignClass {
        justify-content: flex-end;
        align-items: flex-end;
    }
    .dotsClass {
        margin: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/demands/shared/Evaluation.vue